import React from 'react';
import { Breadcrumb, BreadcrumbItem, Col, Grid, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { routes } from '../../../../constants';
import AdminTaskTable from './admin-task-table';

const AdminTaskGroupDetails = ({ match }) => {
  const adminTaskGroupId = parseInt(match.params.adminTaskGroupId, 10)

  return <div className='base-layout'>
    <section className='layout--header'>
      <Grid>
        <Row className='sm-gutter'>
          <Col xs={12}>
            <Breadcrumb>
              <LinkContainer to={routes.adminPortal.adminTaskGroup}>
                <BreadcrumbItem>
                  Administrative Tasks
                </BreadcrumbItem>
              </LinkContainer>
              <BreadcrumbItem active>
                Administrative Task Group
              </BreadcrumbItem>
            </Breadcrumb>
          </Col>
        </Row>
        <Row className='button-gutter'>
          <Col xs={12}>
            <h1>Administrative Task Group</h1>
          </Col>
        </Row>
      </Grid>
    </section>
    <section id='section--admin-task' className='layout--section'>
      <Grid>
        <Row className='no-gutter sectionHeader'>
          <AdminTaskTable adminTaskGroupId={adminTaskGroupId} />
        </Row>
      </Grid>
    </section>
  </div>
}

export default AdminTaskGroupDetails


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/admin-task-portal/admin-task-group-details.js